import { Entity } from "src/app/core/utils/entity";

export abstract class MultiCompanyFileEntity extends Entity {
    constructor(
        public file: string,  
    ) {
        super();
    }
}